/**
 * Company: AltSolution
 * Author: Ivan Horobets
 */

"use strict";
$(document).ready(function () {
    if ('storiesObj' in window) {

        //Slider three image
        let $threeSliders = $('.story_three_slider');
        if ($(window).width() <= 767) {
            $threeSliders.addClass('owl-carousel owl-theme');
            $threeSliders.owlCarousel({
                loop: false,
                margin: 10,
                dots: true,
                nav: false,
                autoWidth: true,
                items: 1
            });
        }

        //Double sliders
        let $sliderSmall = $('.story_double_small_slider'),
            $sliderBig = $('.story_double_big_slider'),
            initialSliders = {};

        //Remove mobile blocks
        if($(window).width() >= 768) {
            $sliderSmall.find('.item.d-md-none').remove();
        }

        $sliderSmall.each(function () {
            let $thisInit = $(this).owlCarousel({
                loop: false,
                margin: 10,
                dots: true,
                nav: false,
                autoWidth: true,
                items: 1,
                responsive: {
                    768: {
                        nav: true,
                        mouseDrag: false,
                        touchDrag: false,
                        pullDrag: false
                    }
                }
            });

            if($(window).width() >= 768) {
                initialSliders[$(this).attr('data-index')] = {
                    'small': $thisInit,
                };

                //Change slide
                let $this = $(this);
                $thisInit.on('changed.owl.carousel', function(event) {
                    initialSliders[$this.attr('data-index')].big.trigger('to.owl.carousel', event.item.index);
                })
            }

        });

        if($(window).width() >= 768) {
            $sliderBig.each(function () {
                let $thisInit = $(this).owlCarousel({
                    loop: false,
                    margin: 10,
                    dots: false,
                    nav: false,
                    autoWidth: true,
                    items: 1,
                    responsive: {
                        768: {
                            mouseDrag: false,
                            touchDrag: false,
                            pullDrag: false
                        }
                    }
                });

                initialSliders[$(this).attr('data-index')]['big'] = $thisInit
            });
        }
    }
});